<template>
  <base-page-layout class="interesses" title="Interesses" :filters="['lojas', 'clientes', 'clube', 'data', 'segmentos']" default-date="desdeInicio">
    <mf-tabs-menu v-model="currentTab" class="interest-tabs" :tabs="permissionedInterestTabs"></mf-tabs-menu>
    <router-view />
  </base-page-layout>
</template>

<script>
import BasePageLayout from '@/components/BasePageLayout.vue'

export default {
  components: {
    BasePageLayout,
  },
  data: () => ({
    currentTab: null,
  }),
  computed: {
    interestTabs() {
      return [
        {
          name: 'Interesses por gênero',
          to: '/clientes/interesses/por-genero',
          tabPermission: 'clientes/interesses/genero',
        },
        {
          name: 'Interesses por idade',
          to: '/clientes/interesses/por-idade',
          tabPermission: 'clientes/interesses/idade',
        },
        {
          name: 'Interesses pessoa jurídica',
          to: '/clientes/interesses/pessoa-juridica',
          tabPermission: 'clientes/interesses/pessoa_juridica',
        },
      ]
    },
    permissionedInterestTabs() {
      let tabs = []
      this.interestTabs.forEach((tab) => {
        if (this.$permissions.havePagePermission(tab.tabPermission)) {
          tabs.push(tab)
        }
      })
      return tabs
    },
  },
  watch: {
    currentTab(tab) {
      if (this.$route.path !== this.permissionedInterestTabs[tab].to) {
        this.$router.push(this.permissionedInterestTabs[tab].to)
      }
    },
  },
  mounted() {
    this.setInitialTab()
  },
  beforeUpdate() {
    this.setInitialTab()
  },
  methods: {
    setInitialTab() {
      if (this.$getLoggedUser().is_franchise) {
        console.log('restrict-access:4')
        this.$router.push({ path: '/restrict-access' })
        return
      }
      if (this.$route.path === '/clientes/interesses') {
        this.$router.push(this.permissionedInterestTabs[0].to)
        this.currentTab = 0
        return
      }
      const index = this.permissionedInterestTabs.findIndex((p) => p.to === this.$route.path)
      this.currentTab = index === -1 ? 0 : index
    },
  },
}
</script>

<style lang="scss" scoped>
.interest {
  &-tabs {
    padding-top: 8px;
  }
}
</style>
